import { ChevronLeftIcon, ChevronRightIcon, EyeIcon, SearchIcon } from '@heroicons/react/outline'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getallCustomers } from '../Redux/Action/order.action';
import { Backdrop, CircularProgress, Pagination } from '@mui/material';
import { FormatAmount, formatDate } from '../Controllers/FormatAmount';
import { CaretDownFill, CaretUpFill, Plus } from 'react-bootstrap-icons';
import { getAllCustomers } from '../Redux/Action/customer.action';
import Popup from '../Controllers/Popup';
import AddCustomer from '../Controllers/AddCustomer';
import EditCustomer from '../Controllers/EditCustomer';
import { useNavigate } from 'react-router-dom';

const CustomerTable = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { allCustomers, customersLoader } = useSelector((state) => state.customerReducer)
    const { staffInfo } = useSelector((state) => state?.authReducer)
    const [Page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);
    const [search, setSearch] = useState();
    const [sortBy, setSortBy] = useState('');
    const [iconVisible, setIconVisible] = useState(false);
    const [orderBy, setOrderBy] = useState({ orderByValue: 'DESC', isDecending: false });
    const [openCustomerPopup, setOpenCustomerPopup] = useState(false)
    const [openCustPopup, setOpenCustPopup] = useState(false)
    const [editData, setEditData] = useState();
    var startRecord = (allCustomers?.currentPage - 1) * limit + 1;
    var endRecord = Math.min(
        allCustomers?.currentPage * limit,
        allCustomers?.totalRecords,
    );
    const SortData = () => {
        if (!orderBy.isDecending) {
            setOrderBy({ orderByValue: 'DESC', isDecending: true });
        } else {
            setOrderBy({ orderByValue: 'ASC', isDecending: false });
        }
    };
    const closeCustomerPopup = () => {
        setOpenCustomerPopup(false)
    }
    const closeCustPopup = () => {
        setOpenCustPopup(false)
    }
    useEffect(() => {
        dispatch(getAllCustomers(search, Page, limit))
    }, [search, Page])
    return (
        <>
            {customersLoader && <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={customersLoader}
                className='flex flex-col'
            >
                <CircularProgress color='inherit' />
                <p>Loading...</p>
            </Backdrop>}
            <div className='flex flex-col gap-5'>
                <div className='flex flex-wrap gap-2 items-center justify-between'>
                    <div className='relative flex-grow'>
                        <SearchIcon className='input-icon w-5 h-5' />
                        <input type='text' placeholder='Search customer' value={search} onChange={(e) => setSearch(e.target.value)} className='!pl-10 w-full' />
                    </div>
                    <div>
                        <button type='button' className='btn-primary flex items-center' onClick={() => setOpenCustomerPopup(true)}><Plus /> Add Customer</button>
                    </div>
                </div>
                {allCustomers?.records?.length > 0 ?
                    <div className='rounded-[10px] overflow-auto border border-color'>
                        <table className='w-full'>
                            <thead>
                                <tr>
                                    <td>
                                        <button
                                            type='button'
                                            className={`${iconVisible && sortBy === 'name' ? 'text-gray-700' : ''}`}
                                            onMouseEnter={() => {
                                                setIconVisible(true);
                                                setSortBy('name');
                                            }}
                                            onMouseLeave={() => {
                                                setIconVisible(false);
                                                setSortBy('');
                                            }}
                                            onClick={() => SortData('name')}
                                        >
                                            <div className='flex items-center'>
                                                Name {iconVisible && sortBy === 'name' ? (
                                                    !orderBy.isDecending ? (
                                                        <CaretUpFill className='ms-2' />
                                                    ) : (
                                                        <CaretDownFill className='ms-2' />
                                                    )
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                        </button>
                                    </td>
                                    <td>Phone</td>
                                    <td>Orders</td>
                                    <td className='w-full text-right'>action</td>
                                </tr>
                            </thead>
                            <tbody className='divide-y border-color'>
                                {allCustomers?.records?.map((elem, index) => (
                                    <tr className='cursor-pointer' key={index} onClick={(e) => { e.stopPropagation(); navigate({ pathname: '/transaction', search: `?customer_id=${elem?._id}`, }); }}>
                                        <td>{elem?.name || '-'}</td>
                                        <td>{elem?.phone || '-'}</td>
                                        <td>{elem?.order_count || '-'}</td>
                                        <td className='w-full text-right'>
                                            <button
                                                type='button'
                                                className='w-[30px] h-[30px] inline-flex items-center justify-center bg-[#F4FDF5] text-[#238823] border border-[#2388231A] hover:border-[#238823] rounded-full transition-all duration-200'
                                                onClick={(e) => { e.stopPropagation(); setOpenCustPopup(true); setEditData(elem) }}
                                            >
                                                <EyeIcon className='w-4 h-4' />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    :
                    <div className='w-full h-auto bg-white flex items-center justify-center border mb-2.5 rounded-[6px] p-5'>
                        No Transaction Found
                    </div>
                }
                {allCustomers ? (
                    <div className='bg-white border main-border-color flex flex-1 p-5 items-center justify-between pagination overflow-hidden rounded-[6px]'>
                        <span className='text-sm font-medium'>
                            {limit === 'all'
                                ? `${allCustomers?.totalRecords}` + ' ' + `records`
                                : `${startRecord} - ${endRecord} of ${allCustomers?.totalRecords
                                } records`}
                        </span>
                        <div>
                            {allCustomers?.totalPages !== 1 ? (
                                <Pagination
                                    count={allCustomers?.totalPages}
                                    page={Page}
                                    onChange={(e, v) => setPage(v)}
                                />
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                ) : (
                    <></>
                )}
            </div>
            <Popup showPopup={openCustomerPopup} closePopup={closeCustomerPopup} callComponant={<AddCustomer setOpenCustomerPopup={setOpenCustomerPopup} />} closebtn={true} />
            <Popup showPopup={openCustPopup} closePopup={closeCustPopup} callComponant={<EditCustomer editData={editData} setOpenCustPopup={setOpenCustPopup} />} closebtn={true} />
        </>
    )
}

export default CustomerTable